import Welcome from "@/pages/welcome/Welcome";
import {createFileRoute} from "@tanstack/react-router";
import {zodValidator} from "@tanstack/zod-adapter";
import {z} from "zod";

export const Route = createFileRoute("/_authenticated/company/$companyId/welcome")({
  component: Welcome,
  params: {
    parse: raw => ({companyId: +raw.companyId}),
    stringify: params => ({companyId: params.companyId?.toString()}),
  },
  validateSearch: zodValidator(
    z.object({
      country: z.string().optional(),
    }),
  ),
});
